import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { X, Cookie } from "lucide-react";

const COOKIE_CONSENT_KEY = "velocity_cookie_consent";

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);
  const [animateIn, setAnimateIn] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      setVisible(true);
      // Small delay for animation
      setTimeout(() => setAnimateIn(true), 50);
    }
  }, []);

  const acceptAll = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify({
      essential: true,
      analytics: true,
      functional: true,
      timestamp: new Date().toISOString(),
    }));
    setAnimateIn(false);
    setTimeout(() => setVisible(false), 300);
  };

  const acceptEssential = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify({
      essential: true,
      analytics: false,
      functional: false,
      timestamp: new Date().toISOString(),
    }));
    setAnimateIn(false);
    setTimeout(() => setVisible(false), 300);
  };

  if (!visible) return null;

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-[100] transition-transform duration-300 ease-out ${
        animateIn ? "translate-y-0" : "translate-y-full"
      }`}
    >
      <div className="bg-navy-deep/98 backdrop-blur-xl border-t border-teal/20 shadow-[0_-10px_40px_rgba(0,0,0,0.3)]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-5">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
            <div className="flex items-start gap-4">
              <div className="hidden sm:flex items-center justify-center w-10 h-10 rounded-full bg-teal/10 text-teal flex-shrink-0 mt-0.5">
                <Cookie className="w-5 h-5" />
              </div>
              <div>
                <p className="text-sm text-white/90 font-body leading-relaxed">
                  We use cookies to enhance your experience on our website. 
                  Essential cookies are always active. You can choose whether to allow analytics and functionality cookies.{" "}
                  <Link
                    to="/cookies"
                    className="text-teal hover:text-teal-light underline underline-offset-2 transition-colors"
                    onClick={() => {
                      setAnimateIn(false);
                      setTimeout(() => setVisible(false), 300);
                    }}
                  >
                    Learn more
                  </Link>
                </p>
              </div>
            </div>
            <div className="flex items-center gap-3 flex-shrink-0 w-full md:w-auto">
              <button
                onClick={acceptEssential}
                className="flex-1 md:flex-none px-5 py-2.5 text-sm font-body font-medium text-white/80 border border-white/20 rounded-full hover:bg-white/5 transition-all duration-200"
              >
                Essential Only
              </button>
              <button
                onClick={acceptAll}
                className="flex-1 md:flex-none px-5 py-2.5 text-sm font-body font-bold text-navy-deep bg-gradient-to-r from-teal to-teal-light rounded-full hover:shadow-lg hover:shadow-teal/25 transition-all duration-200"
              >
                Accept All
              </button>
              <button
                onClick={() => {
                  setAnimateIn(false);
                  setTimeout(() => setVisible(false), 300);
                }}
                className="p-2 text-white/40 hover:text-white transition-colors flex-shrink-0"
                aria-label="Close cookie banner"
              >
                <X className="w-4 h-4" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
